import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'

import { LayoutContext } from 'App'
import AccountSwitcherModal from './AccountSwitcherModal'
import { useAccountSwitcher } from './useAccountSwitcher'
import { getAccountInitials } from './accountAvatar'
import { ChevronsUpDownIcon } from 'images'

/**
 * Sidebar partner-account switcher: shows the active `partnerId` and opens a
 * modal (fetched from /profile/my-groups) to pick another one. Reuses the same
 * clientId/UPDATE_PARTNER handoff as the login-time PartnerSelect screen, then
 * reloads so every partnerId-scoped fetch across the app (features, permissions,
 * partner details, etc.) re-runs from a clean slate instead of being patched up
 * piecemeal.
 */
const AccountSwitcher = () => {
  const { t } = useTranslation()
  const layout = useContext(LayoutContext)
  const { partnerId, hasMultipleAccounts, showModal, setShowModal, switchingAccountId, selectAccount } =
    useAccountSwitcher()

  if (!hasMultipleAccounts) return null

  return (
    <>
      <li className="main-nav__item white-icon mb-0">
        <button
          type="button"
          className="main-nav__link w-100 account-switcher__trigger"
          onClick={() => setShowModal(true)}
          title={partnerId}
          aria-label={t('AccountSwitcher.trigger')}
        >
          <div className="main-nav__link__content align-items-center">
            <span className="account-switcher__avatar" aria-hidden="true">
              {getAccountInitials(partnerId)}
            </span>

            <span
              className={`main-nav__link__label-slot ${
                layout.sidebarExpanded ? 'main-nav__link__label-slot--expanded' : ''
              }`}
            >
              <span
                className="account-switcher__current-label"
                style={{ opacity: layout.sidebarExpanded ? 1 : 0 }}
              >
                {partnerId}
              </span>
            </span>

            {layout.sidebarExpanded && (
              <ChevronsUpDownIcon width={16} height={16} className="fa-solid fa-sort account-switcher__chevron" aria-hidden="true" />
            )}
          </div>
        </button>
      </li>

      <AccountSwitcherModal
        isOpen={showModal}
        currentPartnerId={partnerId}
        switchingAccountId={switchingAccountId}
        onClose={() => setShowModal(false)}
        onSelect={selectAccount}
      />
    </>
  )
}

export default AccountSwitcher
